module.exports = __webpack_public_path__ + "static/img/应用场景5-作业质量.402b9c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type4-1/应用场景5-作业质量.png
// module id = jj5a
// module chunks = 0